import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

import { queryClient } from '~lib/api/queryClient';
import resetTokenToCookie from '~utils/auth/resetTokenToCookie';
import { setAmplitudeUserId } from '~utils/common/thirdPartyEvent';

interface Params {
  reload?: boolean;
}

export default function useLogout() {
  const router = useRouter();
  const isSessionPage = useIsSessionPage();

  const handleLogout = useCallback(
    (params?: Params) => {
      resetTokenToCookie();

      queryClient.removeQueries('myInfo');
      setAmplitudeUserId(null);
      if (isSessionPage) {
        router.push('/');

        return;
      }

      if (params?.reload && router) {
        router.reload();
      }
    },
    [router.route, isSessionPage],
  );

  return handleLogout;
}

function useIsSessionPage() {
  const [isSessionPage, setIsSessionPage] = useState<boolean>();
  const router = useRouter();
  const sessionPage = [
    '/mypage/*',
    '/review/work-life-balance',
    '/review/skill',
    '/review/culture',
    '/review/interview',
  ];

  useEffect(() => {
    let newSessionPage = false;

    sessionPage.forEach((sessionPath) => {
      if (newSessionPage) {
        return;
      }

      const isWildcard = sessionPath.indexOf('*') >= 0;

      if (isWildcard) {
        newSessionPage = router.route.startsWith(sessionPath.replace(/\*/g, ''));
      } else {
        newSessionPage = router.route === sessionPath;
      }

      setIsSessionPage(newSessionPage);
    });
  }, [router.route]);

  return isSessionPage;
}
